import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { SelectOptionLoaderI } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-select/models/select-option-loader-i';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SpecFieldNames } from '@ordersnproducts/modules/order-builder/modules/specification/constants/specification-field-names.enum';
import { getPaymentTerms } from '../redux/payment-terms.selectors';
import { OrderBuilderState } from '@ordersnproducts/modules/order-builder/reducers';
import { SelectOptionI } from '../../configurable-form/components/form-select/models/select-option-i';
import OrdersFormsActions from '@ordersnproducts/modules/multiple-order-online/redux/actions/orders-forms.action';
import { MultipleOrdersState } from '@ordersnproducts/modules/multiple-orders/modules/rms-multiple-orders/reducers/rms-multiple-orders.reducer';
@Injectable()
export class PaymentTermsLoaderRMXULService implements SelectOptionLoaderI {
  constructor(private store: Store<OrderBuilderState>) {}

  /**
   * Provides an observable of paymentTerms
   * @return {Observable<SelectOptionI[]>}
   */
  loadOptions(formGroup: UntypedFormGroup): Observable<SelectOptionI[]> {
    return this.store.pipe(
      select(getPaymentTerms),
      filter((data) => !!data),
      map((availablePaymentTerms) => {
        if (!!availablePaymentTerms && availablePaymentTerms.length > 0) {
          formGroup.get(SpecFieldNames.PAYMENT_TERMS).setValue(availablePaymentTerms[0].paymentTermCode);
          return availablePaymentTerms.map((paymentTerm) => {
            return {
              id: paymentTerm.paymentTermCode,
              name: `${paymentTerm.paymentTermDesc}`,
            };
          });
        }
        return [];
      }),
    );
  }
}

@Injectable()
export class PaymentTermsLoaderRMXULMOOService implements SelectOptionLoaderI {
  constructor(private store: Store<MultipleOrdersState>) {}

  /**
   * Loads payment term options into the provided form group.
   *
   * @param {FormGroup} formGroup - The form group to load options into.
   * @returns {Observable<SelectOptionI[]>} An observable that emits an array of select options.
   *
   * This method performs the following steps:
   * 1. Selects payment terms from the store.
   * 2. Filters out any falsy data.
   * 3. Maps the available payment terms to select options.
   * 4. Sets the first available payment term code to the form control.
   * 5. Dispatches an action to update the form with the selected payment term on MOO.
   */
  loadOptions(formGroup: UntypedFormGroup): Observable<SelectOptionI[]> {
    return this.store.pipe(
      select(getPaymentTerms),
      filter((data) => !!data),
      map((availablePaymentTerms) => {
        const id = formGroup.get(SpecFieldNames.ID).value;
        if (!!availablePaymentTerms && availablePaymentTerms.length > 0) {
          const value = availablePaymentTerms[0].paymentTermCode;
          formGroup.get(SpecFieldNames.PAYMENT_TERMS).setValue(value);
          this.store.dispatch(
            OrdersFormsActions.updateForm({
              formId: id,
              formControlName: SpecFieldNames.PAYMENT_TERMS,
              formControlvalue: value,
              formIsValid: formGroup.valid,
            }),
          );
          return availablePaymentTerms.map((paymentTerm) => {
            return {
              id: paymentTerm.paymentTermCode,
              name: `${paymentTerm.paymentTermDesc}`,
            };
          });
        }
        return [];
      }),
    );
  }
}
